import { render } from "./player.vue?vue&type=template&id=2e07aa66&scoped=true&ts=true"
import script from "./player.vue?vue&type=script&lang=ts"
export * from "./player.vue?vue&type=script&lang=ts"

import "./player.vue?vue&type=style&index=0&id=2e07aa66&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e07aa66"]])

export default __exports__